import React, { useEffect, useState } from 'react';
import './Recommendations.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSignInAlt, faHeart, faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import Header from "./common/Header";
import FeaturedSection from "./common/FeaturedSection";
import httpService from '../services/HttpService'; // Import your HttpService (adjust path as needed)

// Add the Font Awesome icons to the library
library.add(faSignInAlt, faHeart, faShoppingBag);

function RecommendationsPage() {
    const [looks, setLooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLooks = async () => {
            try {
                const response = await httpService.get('/looks').then(response => response.json()); // Use HttpService
                setLooks(response);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchLooks();
    }, []);

    if (loading) {
        return <div></div>;
        // return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <Header />
            <main className="recommendations-main">
                {looks.map((look, index) => (
                    <FeaturedSection
                        key={look.id}
                        title={look.name}
                        buttonText="Детали"
                        imageUrl={look.images[0]?.link || ''}
                        linkTo={`/look/${look.id}`}
                        btnLink={`/look/${look.id}`}
                        reverse={index % 2 !== 0} // Alternate reverse for visual variety
                    >
                        <p>{look.description}</p>
                    </FeaturedSection>
                ))}
            </main>
        </div>
    );
}

export default RecommendationsPage;